var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3827 5.07637C25.2 5.00068 24.9989 4.98087 24.8049 5.01946C24.6109 5.05805 24.4328 5.1533 24.2929 5.29317L16 13.5861V6.00026C16 5.80248 15.9414 5.60914 15.8315 5.44469C15.7216 5.28023 15.5654 5.15206 15.3827 5.07637C15.2 5.00069 14.9989 4.98088 14.8049 5.01947C14.611 5.05806 14.4328 5.15331 14.2929 5.29317L4.29292 15.2932C4.20006 15.386 4.12639 15.4963 4.07613 15.6176C4.02587 15.7389 4 15.8689 4 16.0003C4 16.1316 4.02587 16.2616 4.07613 16.3829C4.12639 16.5043 4.20006 16.6145 4.29292 16.7074L14.2929 26.7074C14.4328 26.8472 14.611 26.9425 14.8049 26.981C14.9989 27.0196 15.2 26.9998 15.3827 26.9241C15.5654 26.8485 15.7216 26.7203 15.8315 26.5558C15.9414 26.3914 16 26.198 16 26.0003V18.4144L24.2929 26.7074C24.4328 26.8472 24.611 26.9425 24.8049 26.981C24.9989 27.0196 25.2 26.9998 25.3827 26.9241C25.5654 26.8485 25.7216 26.7203 25.8315 26.5558C25.9414 26.3914 26 26.198 26 26.0003V6.00026C26 5.80248 25.9414 5.60914 25.8315 5.44469C25.7216 5.28024 25.5654 5.15206 25.3827 5.07637Z",
    fill: "#373473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevLesson);
export default __webpack_public_path__ + "static/media/prev-lesson.eb4a64dda9c083cfab1865b62a0a9fc9.svg";
export { ForwardRef as ReactComponent };